import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { toastsActions } from '@zola-helpers/client';

// Actions
import { invitePartner } from '../../../../actions/AccountInvitationActions';
import { showModal } from '../../../../actions/ModalActions';

// Selectors
import { getActiveOrInvitedPartner } from '../../../../selectors/checklist/checklistSelectors';
import * as userSelectors from '../../../../selectors/user/userSelectors';

import ChecklistInvitePartner from './ChecklistInvitePartner';

export const mapStateToProps = state => ({
  userContext: userSelectors.getUserContext(state),
  partnerStatus: getActiveOrInvitedPartner(state),
  partnerFirstName: userSelectors.getPartnerFirstName(state),
  partnerLastName: userSelectors.getPartnerLastName(state),
});

export const mapDispatchToProps = dispatch => ({
  onSubmit: formData => dispatch(invitePartner(formData))
    .then(() => dispatch(toastsActions.positive({ headline: 'Invite Sent' }))),
  showConfirmationModal: () => dispatch(showModal('REMOVE_OR_REVOKE_PARTNER', {}, { size: 'sm' }))
});

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
  form: 'checklistInvitePartnerForm',
})(ChecklistInvitePartner));



// WEBPACK FOOTER //
// ./src/components/manage/ChecklistV2/ChecklistInvitePartner/index.js